import {confirmSignUp} from 'aws-amplify/auth'
import React from 'react'
import {Button} from 'react-daisyui'
import {useForm} from 'react-hook-form'
import LoadingSpinner, {LoadingSpinnerSize} from '../common/LoadingSpinner'
import clsx from 'clsx'
import {resendSignUpCode} from 'aws-amplify/auth'

export const ConfirmSignUpCodeForm = ({
  username,
  onConfirmed
}: {
  username?: string
  onConfirmed?: Function
}) => {
  const [isConfirming, setIsConfirming] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null)
  const {
    register,
    handleSubmit,
    formState: {errors},
    watch
  } = useForm()

  const handleConfirmCode = async (data: any): Promise<void> => {
    setIsConfirming(true)
    const caseInsensitiveEmail = username
      ? username.toLowerCase()
      : data.email?.toLowerCase()
    try {
      const {isSignUpComplete, nextStep} = await confirmSignUp({
        username: caseInsensitiveEmail,
        confirmationCode: data.confirmationCode
      })
      if (onConfirmed) {
        onConfirmed({nextStep, data})
      }
    } catch (error) {
      setErrorMessage(error.message || 'An error occurred')
    } finally {
      setIsConfirming(false)
    }
  }

  const handleResendCode = async () => {
    // Logic to resend verification code
    setIsConfirming(true)
    await resendSignUpCode({username})
    setIsConfirming(false)
  }

  return (
    <form
      className="grid grid-cols-1 gap-5"
      onSubmit={handleSubmit(handleConfirmCode)}
      aria-live="polite"
    >
      {errorMessage && (
        <div style={{color: 'red'}} role="alert" aria-live="assertive">
          {errorMessage}
        </div>
      )}
      <div>
        {/* {!username ? (
          <div>
            <label className="label pt-6 pb-1" htmlFor="email">
              <span className="label-text">Email</span>
            </label>
            <input
              type="text"
              id="email"
              name="email"
              className="input input-form"
              {...register('email', {required: true})}
              aria-required="true"
              aria-invalid={!!errors.email}
            />
          </div>
        ) : (
          <div>
            We’ve sent a verification code to your email. Please enter it below.
          </div>
        )} */}
        <div>
          We’ve sent a verification code to your email. Please enter it below.
        </div>
        <label className="label pt-6 pb-1" htmlFor="confirmationCode">
          Verification Code
        </label>
        <input
          {...register('confirmationCode', {required: true})}
          type="text"
          id="confirmationCode"
          name="confirmationCode"
          className="input input-form"
          required
          aria-required="true"
          aria-invalid={!!errors.confirmationCode}
        />
      </div>
      {errors.confirmationCode?.type === 'required' && (
        <p className="text-red-500" role="alert" aria-live="assertive">
          Code is required
        </p>
      )}
      <div>
        <Button
          type="submit"
          className="bg-cabana-500 btn-secondary disabled:text-white w-full"
          aria-busy={isConfirming}
          aria-disabled={isConfirming}
        >
          Confirm
        </Button>
      </div>
      <div>
        <Button
          type="button"
          className="btn-link text-cabana-500 w-full"
          onClick={handleResendCode}
          disabled={isConfirming}
        >
          resend code
        </Button>
      </div>
      <div
        className="text-[13px] text-light-midnight italic
        text-center leading-[18px]"
      >
        <p>Can't find the email? Check your spam folder.</p>
        <p>
          Still stuck? Contact us at{' '}
          <a href="mailto:hello@placemakr.com" className="underline">
            hello@placemakr.com
          </a>
        </p>
      </div>
      <div
        className={clsx({hidden: !isConfirming})}
        aria-hidden={!isConfirming}
      >
        <LoadingSpinner size={LoadingSpinnerSize.Small} />
      </div>
    </form>
  )
}
